/**
 * Strongly types the object assign. By setting a target we can only update
 * propertys of this target preventing coders from acidently adding new properties to a value object
 */
export const tassign = <T extends U, U>(target: T, ...source: U[]): T => {
	return Object.assign({}, target, ...source);
};
